import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { MaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryData } from '@/features/maintenanceWorkflow/pages/Show/features/establishmentChoiceEntries/features/auction/types/updatedSummary.type';

interface UseMaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryProps {
  establishmentChoiceEntryId: string | undefined;
  options?: Partial<Omit<UseQueryOptions<
    { data: { data: MaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryData } },
    ErrorResponse,
    MaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryData
  >, 'queryKey' | 'queryFn'>>;
}

export const useMaintenanceEstablishmentChoiceAuctionEntryUpdatedSummary = ({
  establishmentChoiceEntryId,
  options,
}: UseMaintenanceEstablishmentChoiceAuctionEntryUpdatedSummaryProps) => {
  const privateAxios = usePrivateAxios();

  return useQuery({
    enabled: !!establishmentChoiceEntryId,
    queryKey: ['maintenanceEstablishmentChoiceAuctionEntryUpdatedSummary', establishmentChoiceEntryId],
    queryFn: () => {
      return privateAxios.get(`/maintenance/establishment_choice/auction_entries/${establishmentChoiceEntryId}/updated_summary`);
    },
    select: (response) => response?.data?.data,
    ...options
  });
}
